import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, useContext, useRoute, useRouter } from "@nuxtjs/composition-api";
import { BinaryTreeService } from "~/pages/my-team/services/BinaryTreeService";
import { createEventName, GOOGLE_ANALYTICS_EVENT_NAMES, GOOGLE_ANALYTICS_EVENT_TYPES } from "~/constants/gtag-events";
import { ACTIONS as TOAST_ACTIONS } from "~/store/affility/user/feedback/modals/toast-notification/names";
import { ACTIONS as USER_FEEDBACK_ACTIONS } from "~/store/affility/user/feedback/modals/full-loader/names";
import ApiService from "~/core/services/api-interaction/ApiService";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignUpWithEmail',
  emits: ['onSignUp', 'onClose'],
  setup(__props, { emit: $emit }) {



const SignUpSteps = {
    ENTER_EMAIL: 1,
    CREATE_PASSWORD: 2,
    ACCEPT_TERMS: 3,
}

const context = useContext();
const route = useRoute();
const router = useRouter();

const currentStep = ref(SignUpSteps.ENTER_EMAIL);
const referrerCode = ref('');
const isLoading = ref(true);
const isValidRef = ref(false);
const signUpAcceptTerms = ref(null);
const isSigningUpLoading = ref(null);
const sponsorUser = ref({
    username: '',
    walletAddress: '',
});
const signUpFormData = ref({});

const title = computed(() => {
    switch (currentStep.value) {
        case SignUpSteps.ENTER_EMAIL:
            return 'sign_up';
        case SignUpSteps.CREATE_PASSWORD:
            return 'create_your_password';
        default:
            return null;
    }
})

const handleNextStep = (data, nextStep) => {
    signUpFormData.value = { ...signUpFormData.value, ...data };
    currentStep.value = nextStep;
}

const openFullScreenPopup = () => {
    context.store.dispatch(
        `affility/user/feedback/modals/full-loader/${USER_FEEDBACK_ACTIONS.OPEN_FULL_PAGE_LOADING}`,
        context.i18n.t('please_wait')
    );
}

const closeFullScreenPopup = () => {
    context.store.dispatch(`affility/user/feedback/modals/full-loader/${USER_FEEDBACK_ACTIONS.CLOSE_FULL_PAGE_LOADING}`);
}

const handleRegister = async (data) => {
    signUpFormData.value = { ...signUpFormData.value, ...data };
    signUpFormData.value.referral_id = referrerCode.value;

    isSigningUpLoading.value = true;
    openFullScreenPopup();
    try {
        const response = await ApiService.post('/auth/register-user-email', signUpFormData.value);

        setGtagEvents();

        await context.$auth.setUserToken(response.data.token);

        $emit('onSignUp', { email: signUpFormData.value.email });
    } catch (e) {
        onError(e);
        signUpFormData.value.turnstile_response = null;
        signUpAcceptTerms.value?.resetTurnstile();
    } finally {
        isSigningUpLoading.value = false;
        closeFullScreenPopup();
    }
}

const onError = (e) => {
    let errorText = e?.message || "Something went wrong, please refresh the page and try again";
    if (e?.code === 90) {
        errorText = 'provided_email_is_already_in_use';
    } else if (e?.code === 220) {
        errorText = 'provided_username_is_already_taken';
    }

    context.store.dispatch(`affility/user/feedback/modals/toast-notification/${TOAST_ACTIONS.SHOW_ERROR_TOAST}`, {
        description: context.i18n.t(errorText),
    })
}

const setGtagEvents = () => {
    const eventName = createEventName(
        GOOGLE_ANALYTICS_EVENT_NAMES.REGISTRATION,
        GOOGLE_ANALYTICS_EVENT_TYPES.SUCCESS
    );
    context.$gtag.event(eventName, {
        email: signUpFormData.value?.email,
        username: signUpFormData.value?.username,
        walletAddress: signUpFormData.value?.walletAddress,
    });
}

const handleClose = () => {
    const updatedQuery = { ...route.value.query };
    delete updatedQuery.ref;

    router.replace({ query: updatedQuery });
    $emit('onClose');
}

onMounted(async () => {
    if (route.value.query?.ref) {
        referrerCode.value = route.value.query.ref;

        setTimeout(() => {
            console.log(signUpAcceptTerms.value?.$refs?.cfTurnstile)
        }, 2000)

        try {
            isValidRef.value = await BinaryTreeService.validateReferralId(referrerCode.value);

            if (isValidRef.value) {
                sponsorUser.value.username = BinaryTreeService.sponsorUsername;
                sponsorUser.value.walletAddress = BinaryTreeService.sponsorWalletAddress;
            }
        } finally {
            isLoading.value = false;
        }
    }
})

return { __sfc: true,$emit, SignUpSteps, context, route, router, currentStep, referrerCode, isLoading, isValidRef, signUpAcceptTerms, isSigningUpLoading, sponsorUser, signUpFormData, title, handleNextStep, openFullScreenPopup, closeFullScreenPopup, handleRegister, onError, setGtagEvents, handleClose }
}

})